module.exports = "/images/vendor/flag-icon-css/flags/1x1/gi.svg?b0015a50c9f5aacae4427ea95c385a47";